var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.tag,
    {
      directives: [
        {
          name: "movable",
          rawName: "v-movable",
          value: _vm.moveArgs,
          expression: "moveArgs",
        },
      ],
      tag: "component",
      staticClass: "--movable-base",
      style: _vm.position,
      attrs: { "move-disabled": _vm.disabled },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }